export default "__VITE_ASSET__CsN4t5Ul__"